import { useEffect, useState } from 'react';
import formatDate from '../../../helpers/format-date';
import { TransactionCommentTypes } from './types';
import IconEdit from '../../icons/edit';
import IconTrash from '../../icons/trash';
import Textarea from '../../textarea/textarea';

import styles from './comments.module.css';
import ButtonSecondary from '../../button/button-secondary';
import ButtonPseudo from '../../button/button-pseudo';
import { ButtonSize } from '../../button/types';

export default function TransactionComment({
  comment,
  onEditCommentInTransaction,
  editTrancastionCommentIsSuccess,
  editTransactionCommentInProgress,
  editAvailable,
  deleteAvailable,
  user,
  setDeleteCommentConfirmationVisible,
  setSelectedComment,
}: TransactionCommentTypes) {
  const [isEdit, setIsEdit] = useState(false);
  const [commentText, setCommentText] = useState('');

  useEffect(() => {
    if (editTrancastionCommentIsSuccess) {
      setIsEdit(false);
    }
  }, [editTrancastionCommentIsSuccess]);

  useEffect(() => {
    if (comment) {
      setCommentText(comment?.text);
    }
  }, [comment]);

  return (
    <div className={styles.commentItem}>
      <div className={styles.commentItemTop}>
        <div className={styles.commentItemTopLeft}>
          <div className={styles.commentDate}>
            {formatDate(
              (comment?.updatedAt as string) || (comment?.createdAt as string),
              true,
            )}
          </div>
          {user && <div className={styles.commentUser}>{user?.name}</div>}
        </div>
        {!isEdit && (
          <div className={styles.commentItemTopRight}>
            {editAvailable && (
              <button
                type="button"
                className={styles.commentControlButton}
                onClick={() => setIsEdit(true)}
              >
                <IconEdit width={20} height={20} />
              </button>
            )}
            {deleteAvailable && (
              <button
                type="button"
                className={`${styles.commentControlButton} ${styles.commentDeleteButton}`}
                onClick={() => {
                  setDeleteCommentConfirmationVisible(true);
                  setSelectedComment(comment?.id as string);
                }}
              >
                <IconTrash width={20} height={20} />
              </button>
            )}
          </div>
        )}
      </div>
      <div className={styles.commentItemContent}>
        {!isEdit && (
          <div className={styles.commentItemText}>{comment?.text}</div>
        )}
        {isEdit && (
          <div className={styles.textareaWrapper}>
            <Textarea
              name="comment"
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              placeholder="Enter comment..."
              className={styles.commentTextarea}
            />
            <div
              className={`${styles.createCommentControls} ${styles.noMargin}`}
            >
              <ButtonSecondary
                size={ButtonSize.SMALL}
                className={`button-white ${styles.sendCommentButton}`}
                text={
                  editTransactionCommentInProgress
                    ? 'Loading...'
                    : 'Update comment'
                }
                disabled={editTransactionCommentInProgress}
                onClick={() =>
                  onEditCommentInTransaction &&
                  onEditCommentInTransaction({
                    text: commentText,
                    commentId: comment?.id as string,
                  })
                }
              />
              <ButtonPseudo
                size={ButtonSize.SMALL}
                text="Cancel"
                onClick={() => {
                  setCommentText('');
                  setIsEdit(false);
                }}
                disabled={editTransactionCommentInProgress}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
